import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withKeys as _withKeys, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "users" }
const _hoisted_2 = { class: "app-wrapper" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = { class: "first-column-with-icon-type" }
const _hoisted_6 = { class: "name-type-block" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "emq-table-footer" }

import { throttleBtn } from '@/common/tools'
import { getGroupList } from '@/api/operation'
import { SEARCH_FORM_RES_PROPS as colProps } from '@/common/constants'
import CommonPagination from '@/components/commonPagination.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { pick } from 'lodash'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { Refresh, RefreshLeft, Search, Plus } from '@element-plus/icons-vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import GroupUpsert from './components/GroupUpsert.vue'
import SelectOperator from '@/components/SelectOperator.vue'
import { checkMenuShow } from '@/store/tool'
import LinkOperator from '@/components/Links/LinkOperator.vue'
import LinkGroup from '@/components/Links/LinkGroup.vue'
import PermissionLink from '@/components/PermissionLink.vue'

import _ from 'lodash'

import { defineComponent, ref, defineProps } from 'vue'
import { Group } from '@/types/types'

const __default__ = defineComponent({
  name: 'Group',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  hideFilter: {
    type: Boolean,
    default: () => false,
  },
  operatorID: {
    type: String,
    default: () => '0',
  },
},
  setup(__props) {

const props = __props



const { t } = useI18nTl('Operation')

const showGroup = ref({})
const showDialogIsEdit = ref(false)
const showDialog = ref(false)
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const fuzzyParams = ref<Record<string, any>>({})
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('evses-detail')
const { GroupTypes, getGroupTypeDesc } = useProtocolEnums()
const handleReset = () => {
  fuzzyParams.value = {}
  loadGroup()
}
const editGroupDialog = (item: Group) => {
  showGroup.value = _.cloneDeep(item)
  showDialogIsEdit.value = true
  showDialog.value = true
}
const addCardDialog = () => {
  showGroup.value = {}
  showDialogIsEdit.value = false
  showDialog.value = true
}

const loadGroup = async () => {
  lockTable.value = true
  const sendParams = {
    ...fuzzyParams.value,
    pageReq: {
      ...pageParams.value,
    },
  }

  try {
    const { list = [], pageReply = {} } = await getGroupList(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    // tableData.value = list
    tableData.value = list.map((item: any) => ({
      ...item,
      showEnable: !item.ban,
    }))
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}
const loadDatasRefreshLimit = _.throttle(loadGroup, 750)
loadGroup()

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!props.hideFilter)
      ? (_openBlock(), _createBlock(_component_el_form, {
          key: 0,
          class: "search-wrapper",
          onKeyup: _withKeys(loadGroup, ["enter"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: fuzzyParams.value.name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fuzzyParams.value.name) = $event)),
                      placeholder: _ctx.$t('Operation.name'),
                      clearable: "",
                      onClear: loadGroup
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: fuzzyParams.value.type,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fuzzyParams.value.type) = $event)),
                      placeholder: _ctx.$t('Base.type'),
                      clearable: "",
                      onClear: loadGroup
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(GroupTypes), (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.label,
                            value: item.value,
                            key: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                  default: _withCtx(() => [
                    _createVNode(SelectOperator, {
                      modelValue: fuzzyParams.value.operatorId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fuzzyParams.value.operatorId) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_el_col, _mergeProps(_unref(colProps), { class: "col-oper" }), {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      plain: "",
                      icon: _unref(Search),
                      onClick: loadGroup
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('Base.search')), 1)
                      ]),
                      _: 1
                    }, 8, ["icon"]),
                    _createVNode(_component_el_button, {
                      icon: _unref(RefreshLeft),
                      onClick: handleReset
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('Base.reset')), 1)
                      ]),
                      _: 1
                    }, 8, ["icon"])
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onKeyup"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          icon: _unref(Plus),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (addCardDialog()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.create')), 1)
          ]),
          _: 1
        }, 8, ["icon"])), [
          [_directive_role, 'groupCtrl']
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          icon: _unref(Refresh),
          onClick: _unref(loadDatasRefreshLimit)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
          ]),
          _: 1
        }, 8, ["icon", "onClick"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref_key: "TableCom",
        ref: TableCom,
        "row-key": "id"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "name",
            "min-width": "80",
            label: _ctx.$t('Operation.name')
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(LinkGroup, {
                id: row.id,
                name: row.name
              }, null, 8, ["id", "name"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "operatorName",
            "min-width": "80",
            label: _ctx.$t('Operation.operator')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(LinkOperator, {
                    id: row.evseOperatorId,
                    name: row.evseOperatorName
                  }, null, 8, ["id", "name"]),
                  _hoisted_7,
                  _createVNode(LinkOperator, {
                    id: row.operatorId,
                    name: row.operatorName
                  }, null, 8, ["id", "name"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "type",
            "min-width": "80",
            label: _ctx.$t('Operation.type')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(_unref(getGroupTypeDesc)(row.type)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "phone",
            "min-width": "80",
            label: _ctx.$t('Operation.phone')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "balance",
            "min-width": "80",
            label: _ctx.$t('Operation.balance')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "elecPriceDiscount",
            "min-width": "80",
            align: "center",
            label: _ctx.$t('Operation.elecPriceDiscount') + '/' + _ctx.$t('Operation.servicePriceDiscount')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(row.elecPriceDiscount) + "/" + _toDisplayString(row.servicePriceDiscount), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('Base.operation'),
            "class-name": "table-operation"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(PermissionLink, {
                to: {
                name: 'group-detail',
                params: { id: row.id },
              },
                role: ['groupMemeView']
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    plain: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Base.detail')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["to"]),
              (_unref(checkMenuShow)('groupCtrl'))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    size: "small",
                    plain: "",
                    onClick: ($event: any) => (editGroupDialog(row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Base.edit')), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[4] || (_cache[4] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          onLoadPage: loadGroup
        }, null, 8, ["metaData"])
      ]),
      _createVNode(GroupUpsert, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showDialog).value = $event)),
        info: showGroup.value,
        "is-edit": showDialogIsEdit.value,
        onSubmitted: loadGroup
      }, null, 8, ["modelValue", "info", "is-edit"])
    ])
  ]))
}
}

})